import React, { useState, useEffect, useContext } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { Link } from "@mui/material";
import { useMutation, useManualQuery, ClientContext } from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Divider,
  Button,
  Typography,
  IconButton,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";

import styled from "styled-components";

import { REFRESH_TOKEN_MUTATION } from "../../graphQL/user_qry";
import { GET_MEMBER_DASHBOARD_INFO } from "../../graphQL/member";
import { NO_OF_APPLICANTS_QUERY } from "../../graphQL/term_qry";
import { TERM_ALL_IN_SPRINT_PERIODS_QUERY
 } from "../../graphQL/termPeriod";
import { GET_ALL_MEMBERS_IN_TEAM_TERM_QUERY } from "../../graphQL/team_term_member_qry";
import { GET_ALL_TEAMS_IN_TERM_QUERY } from "../../graphQL/team_term_qry";
import { TEAM_TERM_ALL_PERIODS_QUERY } from "../../graphQL/team_term_period_qry";

import { project_url } from "../../constants/Data";

import Header from "./Header.js";

import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";
import Diversity1Icon from "@mui/icons-material/Diversity1";

import ActivitiesDialog from "./ActivitiesDialog.js";
import ResourcesDialog from "./ResourcesDialogFull.js";
import MemberAttendanceInfoDialog from "./MemberAttendanceInfoDialog.js";

const useStyles = makeStyles((theme) => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  root2: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    paddingTop: 0,
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    //height: "870px",
    backgroundColor: "#ffffff",
  },
  container2: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    height: "870px",
    backgroundColor: "#ffffff",
  },
  ComponentDragBox: {
    float: "left",
  },
  FormDropBox: {
    float: "left",
    marginLeft: "5rem",
    marginTop: ".5rem",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#99D4FF",
      color: "#0D47A1",
    },

    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "&.MuiDataGrid-root": {
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 14,
    },
  },
  dataGridFooterStyle: {
    height: 45,
    marginBottom: 0,
    display: "flex",
    alignItems: "center",
    backgroundColor: "#99D4FF",
  },
  dataGridFooterTextStyle: {
    color: "#0D47A1",
    fontSize: 14,
    fontWeight: 700,
    textAlign: "center",
    //marginLeft: 22,
  },
  card: {
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    height: "165px",
    textAlign: "left",
    borderRadius: "8px",
  },
}));

const now = new Date();

const datePart = now.toLocaleDateString("en-US", {
  month: "long",
  day: "numeric",
  year: "numeric",
});

const timePart = now.toLocaleTimeString("en-US", {
  hour: "numeric",
  minute: "2-digit",
  hour12: true,
});


function Applicant() {  
  const [loadData, setLoadData] = useState(false);
  const [loadContent, setLoadContent] = useState(false);

  const [noCurrentSprintFlg, setNoCurrentSprintFlg] = useState(null);
  const [termNoOfApplicants, setTermNoOfApplicants] = useState(0);
  const [sprintStartDate, setSprintStartDate] = useState(null);
  const [sprintEndDate, setSprintEndDate] = useState(null);
  const [termData, setTermData] = useState([]);
  const [teamTermData, setTeamTermData] = useState([]);
  const [periodDataList, setPeriodDataList] = useState([]);
  const [termName, setTermName] = useState("");
  const [teamsList, setTeamsList] = useState([]);
  const [resourcesRow, setResourcesRow] = useState([]);
  const [activitiesRows, setActivitiesRows] = useState([]);
  const [openActivitiesDialog, setOpenActivitiesDialog] = useState(null);
  const [openResourcesDialog, setOpenResourcesDialog] = useState(null);
  const [openAttendanceDialog, setOpenAttendanceDialog] = useState(null);
  const [currentTermMember, setCurrentTermMember] = useState(null); // null = not loaded yet
  const [hasTeam, setHasTeam] = useState(false);

  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);

  let tenantName = "";
  if(localStorage.getItem("tenantName"))
    tenantName = localStorage.getItem("tenantName");

  
  let firstName = "";
  if(localStorage.getItem("firstName"))
    firstName = localStorage.getItem("firstName");


  let lastName = "";
  if(localStorage.getItem("lastName"))
    lastName = localStorage.getItem("lastName");

  let email = "";
  if(localStorage.getItem("email"))
    email = localStorage.getItem("email");

  let clientId = 0;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");

  const [fetchApplicantDashboardInfo] = useManualQuery(GET_MEMBER_DASHBOARD_INFO, {
    fetchPolicy: "network-only",
  });  
  const [noOfTermApplicantsQuery] = useManualQuery(NO_OF_APPLICANTS_QUERY);
  const [getTermInSprintPeriodsQuery] = useManualQuery(TERM_ALL_IN_SPRINT_PERIODS_QUERY);
  const [fetchAllTeamTermResources] = useManualQuery(
    GET_ALL_MEMBERS_IN_TEAM_TERM_QUERY
  );
  const [fetchAllTermTeams] = useManualQuery(GET_ALL_TEAMS_IN_TERM_QUERY);
  const [fetchAllTeamTermPeriods] = useManualQuery(TEAM_TERM_ALL_PERIODS_QUERY);

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);      
    }
  };

  const classes = useStyles();

  const formatter1 = new Intl.DateTimeFormat("en-us", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    fractionalSecondDigits: 3,
    hour12: true,
    timeZoneName: "short",
  });

  const formatter2 = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const dayFormat = (day, format = null) => {
    const dayDate = new Date(day);
    const dayFormat =
      format !== null
        ? formatter1.formatToParts(dayDate)
        : formatter2.formatToParts(dayDate);
    if (format === "DDmonthYYYY") {
      const newFormat =
        dayFormat.find((a) => a.type == "weekday").value +
        ", " +
        dayFormat.find((a) => a.type == "day").value +
        " " +
        dayFormat.find((a) => a.type == "month").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value;
      return newFormat;
    } else if (format === "monthDDYYYY") {
      const newFormat =
        dayFormat.find((a) => a.type == "month").value +
        " " +
        dayFormat.find((a) => a.type == "day").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value;
      return newFormat;
    } else if (format === "YYYYmonthDD") {
      const newFormat =
        dayFormat.find((a) => a.type == "weekday").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value +
        ", " +
        dayFormat.find((a) => a.type == "month").value +
        " " +
        dayFormat.find((a) => a.type == "day").value;
      return newFormat;
    } else {
      const newFormat =
        dayFormat.find((a) => a.type == "month").value +
        "/" +
        dayFormat.find((a) => a.type == "day").value +
        "/" +
        dayFormat.find((a) => a.type == "year").value;
      return newFormat;
    }
  };

  const getTermInSprintPeriods = async (termUuid) => {
    if (termUuid) {
      const {
        loading: loadingTermInSprintPeriods,
        error: errorTermInSprintPeriods,
        data: dataTermInSprintPeriods,
      } = await getTermInSprintPeriodsQuery({
        variables: {
          termUuid: termUuid,
        },
      });

      if (
        !loadingTermInSprintPeriods &&
        dataTermInSprintPeriods &&
        dataTermInSprintPeriods.termAllInSprintPeriodList
      ) {
        setPeriodDataList(
          dataTermInSprintPeriods.termAllInSprintPeriodList
        );

        if (dataTermInSprintPeriods.termAllInSprintPeriodList.length > 0) {
          const firstPeriodStartDate = new Date(
            dataTermInSprintPeriods.termAllInSprintPeriodList[0].startDate
          );
          setSprintStartDate(firstPeriodStartDate.toLocaleDateString("sv-SE"));

          const lastPeriodEndDate = new Date(
            dataTermInSprintPeriods.termAllInSprintPeriodList.slice(-1)[0].endDate
          );
          setSprintEndDate(lastPeriodEndDate.toLocaleDateString("sv-SE"));
        }
      }
    }
  };
  
  useEffect(() => {
    (async () => getApplicantDashboardData())();
  }, []);

  useEffect(() => {
    (() => getResourcesRow())();
  }, [teamsList]);
 
  useEffect(() => {
    (() => getTeamsList())();
  }, [teamTermData]);  

  const getApplicantDashboardData = async () => {
    if ( clientId && email) {
      const {
        loading: loadingDashboardData,
        error: errorDashboardData,
        data: dataDashboardData,
      } = await fetchApplicantDashboardInfo({
        variables: {
          clientId: parseInt(clientId),
          email: email,
        },
      });
      if (dataDashboardData && 
          dataDashboardData.getMemberDashboardInfo) {
        console.log("dataDashboardData:",dataDashboardData)
        const info = dataDashboardData.getMemberDashboardInfo[0];

        // Not in the current sprint: nothing else to load
        if (!info || !info.currentTermMember) {
          setCurrentTermMember(false);
          return;
        }
        setCurrentTermMember(true);

        // In the sprint, but is he assigned to a team?
        setHasTeam(
          Array.isArray(info.teamTermMembers)
            ? info.teamTermMembers.length > 0
            : !!info.teamTermMembers
        );
        if (info.term && info.term.termId){
          const {
            loading: loadingNoOfAppsData,
            error: errorNoOfApps,
            data: dataNoOfApps,
          } = await noOfTermApplicantsQuery({
            variables: {
              termId: parseInt(info.term.termId),
            },
          });
          if (
            !loadingNoOfAppsData &&
            dataNoOfApps &&
            dataNoOfApps.noOfTermApplicants
          ) setTermNoOfApplicants(dataNoOfApps.noOfTermApplicants);
          setTermData(info.term);
          setTeamTermData(info.teamTermMembers);
          setTermName(info.term.name);
          getTermInSprintPeriods(info.term.termUuid
          );
        };        
      }
      if (errorDashboardData) console.log(errorDashboardData);
    };
  };

  const getTeamsList = async () => {
    if (teamTermData) {      
      let rows = [];
      for (const team of teamTermData) {
        let row = [];
        const {
          loading: teamTermResourcesLoading,
          error: teamTermResourcesError,
          data: teamTermResourcesData,
        } = await fetchAllTeamTermResources({
          variables: {
            teamTermId: parseInt(team.teamTermId.teamTermId),
          },
        });
        row["teamId"] = team.teamTermId.teamId.teamId;
        row["teamTermId"] = team.teamTermId.teamTermId;
        row["name"] = team.teamTermId.teamId.name;
        row["desc"] = team.teamTermId.teamId.desc;            
        row["noOfResources"] = team.teamTermId.noOfResources;
        row["noOfMemberResources"] = team.teamTermId.noOfMemberResources;
        row["noOfStaffResources"] = team.teamTermId.noOfStaffResources;
        if (!teamTermResourcesLoading &&
              teamTermResourcesData &&
              teamTermResourcesData.getAllMembersInTeamTerm) {
          row["members"] =
            teamTermResourcesData.getAllMembersInTeamTerm.filter(
              (item) => item.userTypeId.typeName === "Member");
          row["staff"] =
            teamTermResourcesData.getAllMembersInTeamTerm.filter(
              (item) => item.userTypeId.typeName === "Staff");
        };
        rows.push(row);
      };
      setTeamsList(rows);
    };
  };

  const getResourcesRow = () => {
    let members = 0;
    let staff = 0;
    let rows = [];
    teamsList.map((t) => {
      members += t.noOfMemberResources;
      staff += t.noOfStaffResources;
    });
    rows.push({ id: 1, resources: "Members", noOfResources: members });
    rows.push({ id: 2, resources: "Staff", noOfResources: staff });
    setResourcesRow(rows);
    setLoadData(true);
  };

  const getResourcesData = async(team) => {
    if (team.teamTermId) {
      const {
        loading: teamTermResourcesLoading,
        error: teamTermResourcesError,
        data: teamTermResourcesData,
      } = await fetchAllTeamTermResources({
        variables: {
          teamTermId: parseInt(team.teamTermId),
        },
      });

      if (!teamTermResourcesLoading &&
          teamTermResourcesData &&
          teamTermResourcesData.getAllMembersInTeamTerm) {
        setOpenResourcesDialog({ 
          members: team.members, 
          staff: team.staff, 
          teamName: team.name,
          termName: teamTermResourcesData.getAllMembersInTeamTerm[0].teamTermId.termId.name
        });
      };
    };  
  };

  const getAttendanceData = async (teamId, name, teamTermId) => {
    let teamTermPeriodsEventsData = [];
    let members = [];
    let staff = [];
    if (teamTermId){
      const {
        loading: teamTermPeriodsLoading,
        error: teamTermPeriodsError,
        data: teamTermPeriodsData,
      } = await fetchAllTeamTermPeriods({
        variables: {
          teamTermId: parseInt(teamTermId),
        },
      });

      if (
        !teamTermPeriodsLoading &&
        teamTermPeriodsData &&
        teamTermPeriodsData.teamTermAllPeriodList
      ) teamTermPeriodsEventsData = flattenRows2(
          teamTermPeriodsData.teamTermAllPeriodList);

      const {
        loading: teamTermResourcesLoading,
        error: teamTermResourcesError,
        data: teamTermResourcesData,
      } = await fetchAllTeamTermResources({
        variables: {
          teamTermId: parseInt(teamTermId),
        },
      });

      if (!teamTermResourcesLoading &&
          teamTermResourcesData &&
          teamTermResourcesData.getAllMembersInTeamTerm) {
        members = teamTermResourcesData.getAllMembersInTeamTerm.filter(
          (item) => item.userTypeId.typeName === "Member");
        staff = teamTermResourcesData.getAllMembersInTeamTerm.filter(
          (item) => item.userTypeId.typeName === "Staff");
      };
    };
    setOpenAttendanceDialog({
      members: members,
      staff: staff,
      periodRows: teamTermPeriodsEventsData,
      name,
      teamTermId
    });
  };

  const getTeamTermActivitiesData = async (teamTermId, teamName) => {
    if (teamTermId){
      const {
        loading: teamTermPeriodsLoading,
        error: teamTermPeriodsError,
        data: teamTermPeriodsData,
      } = await fetchAllTeamTermPeriods({
        variables: {
          teamTermId: parseInt(teamTermId),
        },
      });

      if (
        !teamTermPeriodsLoading &&
        teamTermPeriodsData &&
        teamTermPeriodsData.teamTermAllPeriodList
      ) setActivitiesRows(flattenRows(
          teamTermPeriodsData.teamTermAllPeriodList
        )
      );
    };
    setOpenActivitiesDialog(teamName);
  };

  const periodColumns = [
    {
      field: "name",
      headerName: "Period Name",
      minWidth: 150,
      flex: 1,
      disableColumnMenu: true,
    },
    {
      field: "startDate",
      headerName: "Start Date",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "endDate",
      headerName: "End Date",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
  ];
  const resourcesColumns = [
    {
      field: "resources",
      headerName: "Resources",
      minWidth: 150,
      flex: 1,
      disableColumnMenu: true,
    },
    {
      field: "noOfResources",
      headerName: "No of Resources",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
  ];
  const teamsColumns = [
    {
      field: "name",
      headerName: "Team Name",
      minWidth: 170,
      //  flex: 1,
      disableColumnMenu: true,
    },
    {
      field: "desc",
      headerName: "Description",
      minWidth: 200,
      flex: 1,
      disableColumnMenu: true,
    },
  ];

  const activitiesColumns = [
    {
      field: "period",
      headerName: "Period",
      headerClassName: "super-app-theme--header",
      minWidth: 130,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        if (params.row.period) {
          return (
            <Typography variant="h2" style={{ paddingTop: 10 }}>
              {params.row.period}
            </Typography>
          );
        } else if (params.row.startDate && params.row.endDate)
          return (
            <Box>
              <Typography variant="h5" className="row-span-empty">
                <b>Start Date:&nbsp;</b>
                {params.row.startDate}
              </Typography>
              <Typography variant="h5" className="row-span-empty">
                <b>End Date:&nbsp;</b>
                {params.row.endDate}
              </Typography>
            </Box>
          );
        return <span className="row-span-empty"></span>;
      },
    },
    {
      field: "event",
      headerClassName: "super-app-theme--header",
      headerName: "Event",
      minWidth: 150,
      sortable: false,
      flex: 1,
      disableColumnMenu: true,
      renderCell: (params) => {
        return <div>{params.value}</div>;
      },
    },
    {
      field: "desc",
      headerName: "Description",
      headerClassName: "super-app-theme--header",
      minWidth: 220,
      sortable: false,
      align: "center",
      flex: 1,
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "100%",
            }}
          >
            {params.value}
          </div>
        );
      },
    },
    {
      field: "scheduledDate",
      headerName: "Scheduled Date",
      headerClassName: "super-app-theme--header",
      minWidth: 170,
      sortable: false,
      align: "center",
      //  flex: 1,
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (params) => {
        return <div>{params.value}</div>;
      },
    },
    {
      field: "actualDate",
      headerClassName: "super-app-theme--header",
      headerName: "Actual Date",
      minWidth: 150,
      sortable: false,
      align: "center",
      //  flex: 1,
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (params) => {
        return <div>{params.value}</div>;
      },
    },
  ];

  const flattenRows = (data) => {
    let rowId = 1;
    let eventRows = [];
    if (data.length === 0) return [];
    data.forEach((period, index) => {
      if (period.teamTermEvents.length > 0 && period.inSprint) {
        period.teamTermEvents.forEach((event, index) => {
          eventRows.push({
            id: rowId++,
            teamTermPeriodId: period.teamTermPeriodId,
            period: index === 0 ? period.name : null, // Only show in the first row
            startDate: index === 1 ? period.startDate : null, // Only show in the secound row
            endDate: index === 1 ? period.endDate : null,
            event: event.name,
            eventType: event.eventType,
            teamTermEventId: event.teamTermEventId,
            desc: event.desc,
            scheduledDate: event.scheduledDate,
            actualDate: event.actualDate,
            attendanceRequired: event.attendanceRequired,
          });
        });
      }
      // For the case that there is not any event under period
      if (period.teamTermEvents.length === 0 && period.inSprint) {
        eventRows.push({
          id: rowId++,
          teamTermPeriodId: null,
          period: period.name,
          startDate: null,
          endDate: null,
          dateRange: null,
          event: null,
          desc: null,
          scheduledDate: "",
          actualDate: "",
        });
      }
    });
    return eventRows;
  };

  const flattenRows2 = (data) => {
    let rowId = 1;
    let eventRows = [];
    if (data.length === 0) return [];
    data.forEach((period, index) => {
      if (period.teamTermEvents.length > 0 && period.inSprint) {
        period.teamTermEvents.forEach((event, index) => {
          if (event.attendanceRequired) {
            eventRows.push({
              id: rowId++,
              teamTermPeriodId: period.teamTermPeriodId,
              period: period.name,
              startDate: period.startDate,
              endDate: period.endDate,
              event: event.name,
              eventType: event.eventType,
              teamTermEventId: event.teamTermEventId,
              desc: event.desc,
              scheduledDate: event.scheduledDate,
              actualDate: event.actualDate,
              attendanceRequired: event.attendanceRequired,
            });
          }
        });
      }
    });
    return eventRows;
  };

  function DataGridTitle() {
    return (
      <Box pt={1}>
        <Typography variant="h1" style={{ fontSize: 18, paddingBottom: 6 }}>
          Periods
        </Typography>
        <Divider />
      </Box>
    );
  }
  function ResourcesTitle() {
    return (
      <Box pt={1}>
        <Typography variant="h1" style={{ fontSize: 18, paddingBottom: 6 }}>
          Resources
        </Typography>
        <Divider />
      </Box>
    );
  }
  function TeamsTitle() {
    return (
      <Box pt={1}>
        <Typography variant="h1" style={{ fontSize: 18, paddingBottom: 6 }}>
          Teams
        </Typography>
        <Divider />
      </Box>
    );
  }
  const customFooter = () => {
    let count = 0;
    resourcesRow.map((r) => {
      if (parseInt(r.noOfResources)) count += r.noOfResources;
    });
    return (
      <Grid container className={classes.dataGridFooterStyle}>
        <Grid item xs={6}>
          <Typography
            className={classes.dataGridFooterTextStyle}
            style={{ textAlign: "left", paddingLeft: 10 }}
          >
            Total
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography
            style={{ textAlign: "center" }}
            className={classes.dataGridFooterTextStyle}
          >
            {count}
          </Typography>
        </Grid>
      </Grid>
    );
  };

  if (loadContent && loadData && currentTermMember === false)
  return (
    <div className={classes.root}>
      <Header breadcrumbs={[{ label: "Dashboard", link: null }]} />
      <div className={classes.container}>
        <Box mt={2} mb={2} textAlign="center">
          <Typography variant="body1" style={{ marginBottom: 10, fontWeight: 600 }}>
            Dashboard
          </Typography>
        </Box>
        <Divider />
        <Box pt={5} pb={5} textAlign="center">
          <Typography variant="h2">You are not in the current sprint.</Typography>
        </Box>
      </div>
    </div>
  );

  if (loadContent && loadData && currentTermMember)
    return (
      <div className={classes.root}>
        <Header breadcrumbs={[{ label: "Dashboard", link: null }]} />
        <div className={classes.container}>
          <Box mt={2} mb={2} textAlign="center">
            <Typography
              variant="body1"
              style={{ marginBottom: 10, fontWeight: 600 }}
            >
              Dashboard
            </Typography>
          </Box>
          <Divider />
          <Grid container style={{ paddingTop: 20 }}>
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Typography style={{ paddingRight: 5 }} variant="h3">
                <strong>Today's Date:</strong> {datePart} - {timePart}
              </Typography>
            </Grid>
            <Grid container style={{ paddingTop: 20 }}>
              <Grid
                item
                xs={5}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography style={{ paddingRight: 5 }} variant="h2">
                  Current Sprint:
                </Typography>
                <Typography variant="h3">{termName}</Typography>
              </Grid>
              <Grid
                item
                xs={6}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  paddingLeft: 65,
                }}
              >
                <Typography style={{ paddingRight: 5 }} variant="h2">
                  No of Seats:
                </Typography>
                {termData && termData.noOfSeats && (
                  <Typography variant="h3">
                    {termData.noOfSeats}
                  </Typography>
                )}
              </Grid>
              <Grid
                item
                xs={5}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography style={{ paddingRight: 5 }} variant="h2">
                  Start Date:
                </Typography>
                {sprintStartDate && (
                  <Typography variant="h3">
                    {dayFormat(sprintStartDate.substring(0, 10), "monthDDYYYY")}
                  </Typography>
                )}
              </Grid>
              <Grid
                item
                xs={6}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  paddingLeft: 65,
                }}
              >
                <Typography style={{ paddingRight: 5 }} variant="h2">
                  No of Applicants:
                </Typography>

                <Typography variant="h3">
                  {termNoOfApplicants}
                </Typography>
              </Grid>
              <Grid
                item
                xs={5}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography style={{ paddingRight: 5 }} variant="h2">
                  End Date:
                </Typography>
                {sprintEndDate && (
                  <Typography variant="h3">
                    {dayFormat(sprintEndDate.substring(0, 10), "monthDDYYYY")}
                  </Typography>
                )}
              </Grid>
              <Grid
                item
                xs={6}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  paddingLeft: 65,
                }}
              >
                <Typography style={{ paddingRight: 5 }} variant="h2">
                  No of Teams:
                </Typography>
                <Typography variant="h3">{teamsList.length}</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={3}
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Grid item md={5}>
              <Box pt={4}>
                <DataGrid
                  className={classes.dataGridStyle}
                  columns={periodColumns}
                  rows={periodDataList}
                  showCellRightBorder={true}
                  hideFooter={true}
                  autoWidth={true}
                  autoHeight={true}
                  slots={{
                    toolbar: DataGridTitle,
                  }}
                  rowHeight={40}
                  getRowId={(row) => row.periodId}
                />
              </Box>
            </Grid>
            {hasTeam && (
            <>
              <Grid item md={3}>
                <Box pt={4}>
                  <DataGrid
                    className={classes.dataGridStyle}
                    columns={resourcesColumns}
                    rows={resourcesRow}
                    showCellRightBorder={true}
                    //  hideFooter={true}
                    autoWidth={true}
                    autoHeight={true}
                    slots={{
                      toolbar: ResourcesTitle,
                      footer: customFooter,
                    }}
                    hideFooterSelectedRowCount
                    rowHeight={40}
                    getRowId={(row) => row.id}
                  />
                </Box>
              </Grid>
              <Grid item md={4}>
                <Box pt={4}>
                  <DataGrid
                    className={classes.dataGridStyle}
                    columns={teamsColumns}
                    rows={teamsList}
                    showCellRightBorder={true}
                    hideFooter={true}
                    autoWidth={true}
                    autoHeight={true}
                    slots={{
                      toolbar: TeamsTitle,
                    }}
                    rowHeight={40}
                    getRowId={(row) => row.teamId}
                  />
                </Box>
              </Grid>
            </>
            )}
          </Grid>
          {hasTeam ? (
          <>
            <Typography
              variant="body1"
              gutterBottom
              style={{
                paddingTop: 10,
              }}
            >
              <b>Teams</b>
            </Typography>
            <Box pt={3} pb={5} sx={{ flexGrow: 1 }}>
              <Grid container spacing={3}>
                {teamsList.map((team) => (
                  <Grid item md={4} key={team.teamId}>
                    <Card sx={{ height: "100%" }} className={classes.card}>
                      <Typography
                        variant="h3"
                        gutterBottom
                        style={{
                          paddingTop: 10,
                          paddingBottom: 5,
                          paddingLeft: 20,
                          paddingRight: 20,
                          textAlign: "center",
                        }}
                      >
                        {team.name}
                      </Typography>
                      <Divider style={{ height: 0, backgroundColor: "transparent", borderBottom: "1px solid rgba(0, 0, 0, 0.12)" }} />
                      <Typography
                        variant="h3"
                        style={{
                          paddingTop: 10,
                          paddingBottom: 10,
                          paddingLeft: 20,
                          paddingRight: 20,
                        }}
                      >
                        <b>Members:</b>&nbsp; {team.members.length}
                      </Typography>
                      <Typography
                        variant="h3"
                        style={{
                          paddingBottom: 10,
                          paddingLeft: 20,
                          paddingRight: 20,
                        }}
                      >
                        <b>Staff:</b>&nbsp; {team.staff.length}
                      </Typography>
                      <Box pl={2} pr={1}>
                        <Grid container spacing={3}>
                          <Grid
                            item
                            md={4}
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <IconButton style={{ padding: 0 }}>
                              <CalendarMonthOutlinedIcon
                                onClick={() => 
                                  getTeamTermActivitiesData(
                                    team.teamTermId, 
                                    team.name
                                  )
                                }
                              />
                            </IconButton>
                            <Typography
                              variant="h3"
                              style={{
                                paddingLeft: 5,
                              }}
                            >
                              <Link
                                href="/"
                                underline="none"
                                sx={{ color: "inherit" }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  getTeamTermActivitiesData(
                                    team.teamTermId, 
                                    team.name
                                  )                                
                                }}
                              >
                                Activites
                              </Link>
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            md={4}
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <IconButton style={{ padding: 0 }}>
                              <Diversity1Icon
                                onClick={() =>
                                  getResourcesData(team)
                                }
                              />
                            </IconButton>
                            <Typography
                              variant="h3"
                              style={{
                                paddingLeft: 5,
                              }}
                            >
                              <Link
                                href="/"
                                underline="none"
                                sx={{ color: "inherit" }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  getResourcesData(team);
                                }}
                              >
                                Resources
                              </Link>
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            md={4}
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <IconButton style={{ padding: 0 }}>
                              <HowToRegOutlinedIcon
                                onClick={() =>
                                  getAttendanceData(
                                    team.teamId,
                                    team.name,
                                    team.teamTermId
                                  )
                                }
                              />
                            </IconButton>
                            <Typography
                              variant="h3"
                              style={{
                                paddingLeft: 5,
                              }}
                            >
                              <Link
                                href="/"
                                underline="none"
                                sx={{ color: "inherit" }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  getAttendanceData(
                                    team.teamId, 
                                    team.name,
                                    team.teamTermId
                                  );
                                }}
                              >
                                Attendance
                              </Link>
                            </Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </>
        ) : (
          <Box pt={5} pb={5} textAlign="center">
            <Typography variant="h2">You are not assigned to any team.</Typography>
          </Box>
        )}
        {openActivitiesDialog && (
            <ActivitiesDialog
              name={openActivitiesDialog}
              columns={activitiesColumns}
              rows={activitiesRows} 
              closeDialog={() => setOpenActivitiesDialog(false)}
            />
          )}
          {openResourcesDialog && (
            <ResourcesDialog
              teamName={openResourcesDialog.teamName}
              termName={openResourcesDialog.termName}
              members={openResourcesDialog.members}
              staff={openResourcesDialog.staff}
              closeDialog={() => setOpenResourcesDialog(null)}
            />
          )}
          {openAttendanceDialog && (
            <MemberAttendanceInfoDialog
              teamTerm={openAttendanceDialog.name}
              membersList={openAttendanceDialog.members}
              staffList={openAttendanceDialog.staff}
              teamTermPeriodEvents={openAttendanceDialog.periodRows}
              closeDialog={() => setOpenAttendanceDialog(null)}
            />
          )}
        </div>
      </div>
    );
  else return; 
}

export default Applicant;
